import React from 'react';
import { useQuery } from 'react-query';
import {
  DataGrid,
  GridColDef,
  GridPageChangeParams,
  GridSortModel,
  GridSortModelParams,
} from '@material-ui/data-grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { useEnergyApi } from '../_api/EnergyApiContext';
import RecRegistryAccount, { RecRegistryAccountRequest } from '../_api/data/RecRegistryAccount'
import { Paginated } from '../_api/data/pagination'


import { useForm } from 'react-hook-form';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 100 },
  { field: 'name', headerName: 'Name', flex: 1 },
  { field: 'status', headerName: 'Status', width: 100 },
  { field: 'registeredPersonNumber', headerName: 'RPN', width: 100 },
];

export interface SearchFormData {
  search?: string
}

const RecRegistryAccounts: React.FC = (): React.ReactElement => {
  const classes = useStyles();
  const energyApi = useEnergyApi();
  const [request, setRequest] = React.useState(new RecRegistryAccountRequest())
  const { register, handleSubmit } = useForm<SearchFormData>()

  const queryAccounts = (): Promise<Paginated<RecRegistryAccount>> => {
    return energyApi.getRecRegistryAccounts(request)
  }

  const searchFormSubmit = (data: SearchFormData) => {
    if (request.search !== data.search) {
      request.search = data.search
      request.page = 0
      setRequest(request)
    }
  };

  const handlePageChange = (params: GridPageChangeParams) => {
    const newRequest = RecRegistryAccountRequest.copy(request);
    newRequest.page = params.page
    newRequest.per = params.pageSize
    setRequest(newRequest);
  };

  const setSortModel = (model: GridSortModel) => {
    const newRequest = RecRegistryAccountRequest.copy(request);
    newRequest.sort = model
    setRequest(newRequest);
  };

  const handleSortModelChange = (params: GridSortModelParams) => {
    if (params.sortModel !== request.sort) {
      setSortModel(params.sortModel);
    }
  };

  // Queries
  const {
    isLoading,
    isError,
    error,
    data,
    isFetching,
    isPreviousData,
  } = useQuery<Paginated<RecRegistryAccount>, Error>(['recRegistryAccounts', request], (queryAccounts), { keepPreviousData: true });

  // Mutations
  // const mutation = useMutation(postTodo, {
  //   onSuccess: () => {
  //     // Invalidate and refetch
  //     queryClient.invalidateQueries('todos')
  //   },
  // });

  if (isLoading) {
    return <span>Loading...</span>
  }

  if (isError) {
    return <span>Error...</span>
  }

  if (data) {
    return (
      <>
        <h1>Accounts</h1>
        <form noValidate onSubmit={handleSubmit(searchFormSubmit)}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="search"
            label="Search"
            name="search"
            autoFocus
            inputRef={register}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
          >
            Search
          </Button>
        </form>
        <div style={{ height: 500, width: '100%' }}>
          <DataGrid
            rows={data.items}
            columns={columns}
            pagination
            pageSize={request.per}
            onPageSizeChange={handlePageChange}
            page={data.metadata.page}
            rowCount={data.metadata.total}
            paginationMode="server"
            sortingMode="server"
            onSortModelChange={handleSortModelChange}
            onPageChange={handlePageChange}
            loading={isLoading}
            disableColumnFilter
          />
        </div>
      </>
    )
  }

  return <span>Error</span>
};

export default RecRegistryAccounts;
